export enum ApplicationStep {
  User = "User",
  Context = "Context",
  Applicant = "Applicant",
  ApplicantAddress = "ApplicantAddress",
  ApplicantID = "ApplicantID",
  ApplicantCurrentMortgage = "ApplicantCurrentMortgage",
  ApplicantEmployment = "ApplicantEmployment",
  ApplicantAssets = "ApplicantAssets",
  ApplicantLiabilities = "ApplicantLiabilities",
  ApplicantBankingDetails = "ApplicantBankingDetails",
  CoApplicant = "CoApplicant",
  CoApplicantAddress = "CoApplicantAddress",
  CoApplicantID = "CoApplicantID",
  CoApplicantCurrentMortgage = "CoApplicantCurrentMortgage",
  CoApplicantEmployment = "CoApplicantEmployment",
  CoApplicantAssets = "CoApplicantAssets",
  CoApplicantLiabilities = "CoApplicantLiabilities",
  CoApplicantBankingDetails = "CoApplicantBankingDetails",
  SelfDeclaration = "SelfDeclaration",
  Review = "Review",
  Success = "Success",
}
